<template>
    <v-app-bar app color="primary" absolute>
        <div
            class="d-flex align-center"
            @click="
                () => {
                    this.$router.replace('/');
                }
            "
        >
            <v-img src="@/assets/logo.png" height="95%"></v-img>
        </div>
        <v-spacer></v-spacer>
        <div class="hidden-sm-and-down">
            <navbtns />
        </div>
        <v-menu>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    class="hidden-md-and-up"
                    text
                    light
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon>
                        fas fa-bars
                    </v-icon>
                </v-btn>
            </template>
            <navbtns />
        </v-menu>
    </v-app-bar>
</template>

<script>
import store from "../../store";
import navbtns from "./navbtns";

export default {
    name: "Navbar",
    store: store,
    data: () => ({
        menu: [
            { icon: "home", title: "Link A" },
            { icon: "info", title: "Link B" },
            { icon: "warning", title: "Link C" }
        ]
    }),
    components: {
        navbtns
        //        tabsss
    },
    created: function() {
        this.$store.state.showAlert = false;
    }
};
</script>
